import { Dispatch } from "redux";
import { getBase64 } from "../../../common/utils/fileToBase64";
import {
    setError,
    setIsLoading,
    updateCertificateModalState,
} from "../CreateCertificateModalSlice";
import { ErrorInterface } from "../../../common/interfaces/ErrorInterface";
import { toast } from "react-toastify";
import { EmployeeInterface } from "../../../common/interfaces/EmployeeInterface";
import { QualificationInterface } from "../../../common/interfaces/QualificationInterface";
import { getUserFullName } from "../../../common/utils/getUserFullName";

interface HandleMultipleCertificatesProps {
    postData: {
        qualification: QualificationInterface;
        employee: EmployeeInterface;
        selectedEducator: string;
        validAt: string;
        expiresAt?: string;
        file: File | null;
    }[];
    dispatch: Dispatch;
    postCreateCertificate: (params: { data: Record<string, unknown> }) => {
        unwrap: () => Promise<unknown>;
    };
}

export const handleMultipleCertificates = async (
    props: HandleMultipleCertificatesProps,
): Promise<void> => {
    const { postData, dispatch, postCreateCertificate } = props;
    let allSuccessful = true;
    dispatch(setIsLoading(true));

    for (const data of postData) {
        const fileFields: Record<string, unknown> = {};
        if (data.file?.name) {
            fileFields.certificate = await getBase64(data.file);
            fileFields.file_name = data.file.name;
        }

        try {
            await postCreateCertificate({
                data: {
                    qualification_id: data.qualification.id,
                    employee_id: data.employee.id,
                    educator_id: data.selectedEducator,
                    valid_at: data.validAt,
                    expires_at: data.expiresAt,
                    ...fileFields,
                },
            }).unwrap();

            toast.success(
                "Certificaat " +
                    data.qualification.name +
                    " is toegevoegd voor " +
                    getUserFullName(data.employee.user),
            );
        } catch (error) {
            const errorData = error as ErrorInterface;
            allSuccessful = false;
            dispatch(setError(errorData.data.message));
            dispatch(setIsLoading(false));

            toast.error(
                "Certificaat " +
                    data.qualification.name +
                    " is niet toegevoegd voor " +
                    getUserFullName(data.employee.user),
            );

            break;
        }
    }

    if (allSuccessful) {
        dispatch(
            updateCertificateModalState({
                isLoading: false,
                error: null,
                isCreateCertificateModalOpen: false,
                selectedQualification: null,
                isAtQualification: false,
                isPostCreateCertificateSuccess: true,
                expiresAtValues: {},
                validAtValues: {},
                educatorValues: {},
                selectedEmployees: [],
                formStep: 1,
            }),
        );
    }
};
